import ColumnLayout from '@amzn/awsui-components-react-v3/polaris/column-layout';
import Container from '@amzn/awsui-components-react-v3/polaris/container';
import FormField from '@amzn/awsui-components-react-v3/polaris/form-field';
import Header from '@amzn/awsui-components-react-v3/polaris/header';
import Input from '@amzn/awsui-components-react-v3/polaris/input';
import Select from '@amzn/awsui-components-react-v3/polaris/select';
import Textarea from '@amzn/awsui-components-react-v3/polaris/textarea';
import Button from '@amzn/awsui-components-react/polaris/button';
import Flash from '@amzn/awsui-components-react/polaris/flash';
import Modal from 'AWS-UI-Components-React/polaris/modal';
import React from 'react';
import { isAdmin } from '../../utils/access-utils';
import { getJSClient } from '../js_client';
import { findOption } from '../reports/utils/buttons';
import { Change, KeyOriginalMapping } from './mapper';
import MappingGroup from './mapping_group';
import MappingImpact from './mapping_impact';
import {
  BOOLEAN_DROPDOWN_ELEMENTS,
  CONTRIBUTION_PROFIT_COMPONENT,
  HCP_DRIVER_LIQUIDATIONS,
  HCP_DRIVER_SOURCE_DROPDOWN_ELEMENTS,
  HCP_DRIVERS_SOURCE_MAP,
  LIQUIDATION_COMPONENTS,
  LIQUIDATION_HCP_DRIVER_SOURCE,
  REALLOCATION_GRAIN,
  REALLOCATION_GRAIN_DROPDOWN_ELEMENTS,
  REALLOCATION_GRAIN_LIQUIDATIONS,
} from './utils';

export class MappingEditor extends React.Component {
  constructor(props) {
    super(props);
    const mapping = props.mapping || {};
    this.state = {
      payload: {
        marketplace: '',
        channel: '',
        component: '',
      },
      mapping,
      componentSelected: false,
      marketplaceSelected: false,
      cpValueMappings: mapping.cpValueMap || [],
      cognosBenchmarkMappings: mapping.cognosBenchmark || [],
      accuracyBenchmarkMappings: mapping.accuracyBenchmark || [],
      reallocationGrain: mapping.reallocationGrain,
      subcomponentRollup: mapping.subcomponentRollup,
      cpSubcomponentRollup: mapping.cpSubcomponentRollup,
      baseFactor: mapping.baseFactor,
      cpDataSource: mapping.cpDataSource,
      hcpAttributeName: mapping.hcpAttributeName,
      phoenixAttributeName: mapping.phoenixAttributeName,
      onCancel: props.onCancel,
      onSubmit: props.onSubmit,
      key: 0,
      name: mapping.subComponent,
      oldName: mapping.subComponent,
      disableRename: props.disableRename,
      oWbrCpColumn: props.oWbrCpColumn,
      impactAnalysisVisible: false,
      impactKey: 0,
      validated: false,
      validationMessage: '',
      originalComment: mapping.comment,
      originalBaseFactor: mapping.baseFactor,
      originalCpDataSource: mapping.cpDataSource,
      originalReallocationGrain: mapping.reallocationGrain,
      originalSubcomponentRollup: mapping.subcomponentRollup,
      originalCpSubcomponentRollup: mapping.cpSubcomponentRollup
    };
    this.cognosConfig = props.cognosConfig;
    this.etlConfig = props.etlConfig;
    this.componentConfig = props.componentConfig;
    this.flashbackColumns = props.flashbackColumns;
    this.items = [];

    const o_wbr_cp_columns = [];
    if (this.state.oWbrCpColumn) {
      o_wbr_cp_columns.push({
                              label: this.state.oWbrCpColumn,
                              id: this.state.oWbrCpColumn,
                            });
    }

    if (mapping.component === mapping.subComponent) {
      this.state.cpType = 'O_WBR_CP';
    } else {
      this.state.cpType = 'Last';
    }

    this.state.columnsMap = {
      First: this.flashbackColumns,
      Last: this.flashbackColumns,
      Cognos: this.cognosConfig,
      O_WBR_CP: CONTRIBUTION_PROFIT_COMPONENT.includes(mapping.component) ? this.flashbackColumns : o_wbr_cp_columns,
      ACCRUED_CP: CONTRIBUTION_PROFIT_COMPONENT.includes(mapping.component) ? this.flashbackColumns : o_wbr_cp_columns,
      O_WBR_FIXED_COST: CONTRIBUTION_PROFIT_COMPONENT.includes(mapping.component) ? this.flashbackColumns : o_wbr_cp_columns,
      FCFIXED_COST_ASIN_BY_FC_ACCRUED: CONTRIBUTION_PROFIT_COMPONENT.includes(mapping.component) ? this.flashbackColumns : o_wbr_cp_columns,
    };
    

    this.state.cpValueTypes = [
      {
        label: 'O_WBR_CP',
        id: 'O_WBR_CP',
      },
      {
        label: 'ACCRUED_CP',
        id: 'ACCRUED_CP',
      },
      {
        label: 'O_WBR_FIXED_COST',
        id: 'O_WBR_FIXED_COST',
      },
      {
        label: 'FCFIXED_COST_ASIN_BY_FC_ACCRUED',
        id: 'FCFIXED_COST_ASIN_BY_FC_ACCRUED',
      }
    ];

    this.state.types = [
      {
        label: 'First',
        id: 'First',
      },
      {
        label: 'Cognos',
        id: 'Cognos',
      },
      {
        label: 'Last',
        id: 'Last',
      },
    ];

    for (const etlConfigKey in props.etlConfig) {
      this.state.columnsMap[etlConfigKey] = props.etlConfig[etlConfigKey];
      this.state.types.push({
                              label: etlConfigKey,
                              id: etlConfigKey,
                            });
    }

    this.onNameEdit = this.onNameEdit.bind(this);
    this.onOk = this.onOk.bind(this);
    this.copyToCognosBenchmark = this.copyToCognosBenchmark.bind(this);
  }

  componentWillMount = () => {
    this.client = getJSClient();
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.validate();
  };

  onOk = () => {
    if (this.state.validated) {
      //set original configurations, so that UI can compare original and new to know which fields are modified
      const mapping = this.state.mapping;
      mapping.originalBaseFactor = this.state.originalBaseFactor;
      mapping.originalCpDataSource = this.state.originalCpDataSource;
      mapping.originalReallocationGrain = this.state.originalReallocationGrain;
      mapping.originalSubcomponentRollup = this.state.originalSubcomponentRollup;
      mapping.originalCpSubcomponentRollup = this.state.originalCpSubcomponentRollup;
      mapping.originalComment = this.state.originalComment;
      mapping.originalHcpAttributeName = this.state.originalHcpAttributeName;
      mapping.originalPhoenixAttributeName = this.state.originalPhoenixAttributeName;
      this.setState({mapping}, () => this.state.onSubmit(this.state.name, this.state.oldName));
    }
  };

  onCancelButton = () => {
    this.state.onCancel('closeButton')
  }

  onDismiss = (context) => {
    this.state.onCancel(context.detail.reason)
  }

  onReviewImpact = () => {
    this.setState({ mapping: this.state.mapping, impactAnalysisVisible: true, impactKey: this.state.impactKey + 1 });
  };

  copyToCognosBenchmark = () => {
    const mapping = this.state.mapping;
    const target = [];
    for (const entry of this.state.mapping.accuracyBenchmark) {
      if (entry.type === 'Cognos') {
        target.push(entry);
      }
    }
    mapping.cognosBenchmark = target;
    this.setState({ mapping });
    this.onOk();
  };

  copyToAccuracyBenchmark = () => {
    console.log(this.state.accuracyBenchmarkMappings);
    console.log(this.state.cognosBenchmarkMappings);
    const mapping = this.state.mapping;
    mapping.accuracyBenchmark = this.state.mapping.cognosBenchmark;
    this.setState({ mapping });
    this.onOk();
  };

  onNameEdit = (event) => {
    this.setState({ name: event.detail.value });
  };

  validate = () => {
    let noNulls = true;
    let mappingExists = false;
    let duplicates = false;
    let message = '';
    let entries = {};
    if (this.state.cpValueMappings.length) {
      for (const entry of this.state.cpValueMappings) {
        if (!entry.value) {
          noNulls = false;
          message = 'Incomplete CP Value Mapping';
        } else if (entry.type in entries) {
          duplicates = true;
          message = `Duplicate CP Value Mapping: ${entry.value}`;
        } else {
          entries[entry.value] = entry;
        }
      }
    }
    if (this.state.accuracyBenchmarkMappings.length) {
      entries = {};
      for (const entry of this.state.accuracyBenchmarkMappings) {
        if (entry.type === 'Cognos' && !entry.value && !entry.costCenter) {
          noNulls = false;
          message = 'Incomplete Accuracy Benchmark Mapping: select at least an Account or a Cost Center';
        } else if (entry.type !== 'Cognos' && !entry.value) {
          noNulls = false;
          message = 'Incomplete Accuracy Benchmark Mapping';
        } else {
          const entryKey = entry.type === 'Cognos' ? `${entry.value || 'ALL'}:${entry.costCenter || 'ALL'}` : entry.type;
          if (entryKey in entries) {
            duplicates = true;
            message = `Duplicate Accuracy Benchmark Mapping: ${entry.value || entry.costCenter || entry.type}`;
          } else {
            entries[entryKey] = entry;
          }
        }
      }
    }
    if (this.state.cognosBenchmarkMappings.length) {
      entries = {};
      for (const entry of this.state.cognosBenchmarkMappings) {
        if (!entry.value && !entry.costCenter) {
          noNulls = false;
          message = 'Incomplete P&L Benchmark Mapping: select at least an Account or a Cost Center';
        } else {
          const entryKey = `${entry.value || 'ALL'}:${entry.costCenter || 'ALL'}`;
          if (entryKey in entries) {
            duplicates = true;
            message = `Duplicate P&L Benchmark Mapping: ${entry.value || entry.costCenter}`;
          } else {
            entries[entryKey] = entry;
          }
        }
      }
    }
    this.setState({ key: this.state.key + 1, validated: noNulls && !duplicates, validationMessage: message });
  };

  displayValidationError = () => {
    return (
      <div className="awsui-util-mb-xs">
        <br />
        <Flash
          type="error"
          content={this.state.validationMessage}
          dismissible={true}
        />
      </div>
    )
  };

  displayCostCenterNote = () => {
    return (
      <div className="awsui-util-mb-xs">
        <br />
        <Flash
          content={'For Cognos entries, select an Account and/or Cost Center or both. You can\'t keep both empty.'}
          dismissible={true}
        />
      </div>
    )
  };

  displayReviewImpactMessage = () => {
    return (
      <div className="awsui-util-mb-xs">
        <br />
        <Flash
          content={'Impact Analysis is not yet enabled on sub-components.'}
          dismissible={true}
        />
      </div>
    )
  };

  isReviewImpactEnabled = (mapping) => {
    return !(mapping.component === mapping.subComponent);
  };

  isOkEnabled = () => {
    return !this.state.validated;
  };

  getEditorHeader = (mapping) => {
    return (
      <div>
        <div> Mapping Editor - {mapping.subComponent} </div>
        {this.displayCostCenterNote()}
        {this.isOkEnabled() && this.displayValidationError()}
        {this.isReviewImpactEnabled(mapping) && this.displayReviewImpactMessage()}
      </div>
    )
  };

  getReallocationGrainOptions = (component) => {
    return LIQUIDATION_COMPONENTS.includes(component) ? [...REALLOCATION_GRAIN_DROPDOWN_ELEMENTS, ...REALLOCATION_GRAIN_LIQUIDATIONS]
        : REALLOCATION_GRAIN_DROPDOWN_ELEMENTS;
  };

  getHcpDriverOptions = (component, cpDataSource) => {
    let hcpDriverOptions = HCP_DRIVERS_SOURCE_MAP[cpDataSource];
    return LIQUIDATION_COMPONENTS.includes(component) ? HCP_DRIVER_LIQUIDATIONS
        : hcpDriverOptions || [];
  };

  getHcpDriverSourceOptions = (component) => {
    return LIQUIDATION_COMPONENTS.includes(component) ? LIQUIDATION_HCP_DRIVER_SOURCE
        : HCP_DRIVER_SOURCE_DROPDOWN_ELEMENTS || [];
  };

  getBenchmarkConfigurations = (component) => {
    return (
      <Container
        header={
          <Header variant="h2">
            Accuracy Benchmark Configurations
          </Header>
        }
      >
        <ColumnLayout columns={3} borders="all">
          <FormField label="HCP Driver Source">
            <Select
                selectedOption={findOption(this.getHcpDriverSourceOptions(component, this.state.mapping.cpDataSource), this.state.mapping.cpDataSource)}
                options={this.getHcpDriverSourceOptions(component, this.state.mapping.cpDataSource)}
                onChange={(e) => {
                  this.handleBenchmarkConfigChange(e, 'cpDataSource');
                  if (e.detail.selectedOption.value === 'NONE' ) {
                    const mapping = this.state.mapping;
                    mapping['baseFactor'] = null;
                    mapping.change = this.state[KeyOriginalMapping['baseFactor']] !== mapping['baseFactor'] ? Change.MODIFY: mapping.change;
                    this.setState({ mapping });
                  }
                }}
            />
          </FormField>
          <FormField label="HCP Driver">
            <Select
                selectedOption={findOption(this.getHcpDriverOptions(component, this.state.mapping.cpDataSource), this.state.mapping.baseFactor)}
                options={this.getHcpDriverOptions(component, this.state.mapping.cpDataSource)}
                onChange={(e) => this.handleBenchmarkConfigChange(e, 'baseFactor')}
                disabled={this.state.mapping.cpDataSource == null || this.state.mapping.cpDataSource === 'NONE'}
            />
          </FormField>
          <FormField label="Reallocation Grain">
            <Select
                selectedOption={findOption(this.getReallocationGrainOptions(component), this.state.mapping.reallocationGrain) ||
                    findOption(this.getReallocationGrainOptions(component), REALLOCATION_GRAIN.NONE)}
                options={this.getReallocationGrainOptions(component)}
                onChange={(e) => this.handleBenchmarkConfigChange(e, 'reallocationGrain')}
            />
          </FormField>
          <FormField label="Subcomponent CP Rollup">
            <Select
              selectedOption={findOption(BOOLEAN_DROPDOWN_ELEMENTS, this.state.mapping.cpSubcomponentRollup) ||
              findOption(BOOLEAN_DROPDOWN_ELEMENTS, false)}
              options={BOOLEAN_DROPDOWN_ELEMENTS}
              onChange={(e) => this.handleBenchmarkConfigChange(e, 'cpSubcomponentRollup')}
            />
          </FormField>
          <FormField label="Subcomponent Benchmark Rollup">
            <Select
              selectedOption={findOption(BOOLEAN_DROPDOWN_ELEMENTS, this.state.mapping.subcomponentRollup) ||
              findOption(BOOLEAN_DROPDOWN_ELEMENTS, false)}
              options={BOOLEAN_DROPDOWN_ELEMENTS}
              onChange={(e) => this.handleBenchmarkConfigChange(e, 'subcomponentRollup')}
            />
          </FormField>
        </ColumnLayout>
        <FormField label="Comments">
          <Textarea value={this.state.mapping.comment} onChange={this.onUpdateComment}
                    placeholder="Please provide comment on mappings changes." />
        </FormField>
      </Container>
    );
  };


  onHcpAttributeNameEdit = (event) => {
    const mapping = this.state.mapping;
    mapping.hcpAttributeName = event.detail.value;
    mapping.change = mapping.originalHcpAttributeName !== mapping.hcpAttributeName ? Change.MODIFY: mapping.change;
    this.setState({ mapping });
  };

  onPhoenixAttributeNameEdit = (event) => {
    const mapping = this.state.mapping;
    mapping.phoenixAttributeName = event.detail.value;
    mapping.change = mapping.originalPhoenixAttributeName !== mapping.phoenixAttributeName ? Change.MODIFY: mapping.change;
    this.setState({ mapping });
  };

  onUpdateComment = (event) => {
    const mapping = this.state.mapping;
    mapping.comment = event.detail.value;
    mapping.change = this.state.originalComment !== mapping.comment ? Change.MODIFY: mapping.change;
    this.setState({ mapping });
  };

  handleBenchmarkConfigChange = (event, key) => {
    const mapping = this.state.mapping;
    mapping[key] = event.detail.selectedOption.value;
    mapping.change = this.state[KeyOriginalMapping[key]] !== mapping[key] ? Change.MODIFY: mapping.change;
    this.setState({ mapping });
  };

  render() {
    const { mapping } = this.state;
    return (
      <Modal
        visible
        size="large"
        onDismiss={this.onDismiss}
        header={ this.getEditorHeader(mapping) }
        footer={
          <span className="awsui-util-f-r">
            <Button text="Cancel" onClick={this.onCancelButton} />
            <Button text="Review Impact" disabled={this.isReviewImpactEnabled(mapping)} onClick={this.onReviewImpact} />
            <Button variant="primary" disabled={this.isOkEnabled()} text="Ok" onClick={this.onOk} />
          </span>
        }
        content={
          <div>
            <div>
              <Input
                placeholder="Enter SubComponent Name"
                value={this.state.name}
                disabled={this.state.disableRename}
                onChange={this.onNameEdit}
              />
            </div>
            <br />
            {this.state.impactAnalysisVisible && (
              <MappingImpact key={this.state.impactKey} mapping={this.state.mapping} />
            )}
            <MappingGroup
              title="CP Value Mappings"
              types={[{ label: this.state.cpType, id: this.state.cpType }]}
              cpValueTypesOptions={this.state.cpValueTypes}
              datasetNeeded={true}
              columnsMap={this.state.columnsMap}
              mappingEntries={this.state.cpValueMappings}
              validate={this.validate}
            />
            {
              isAdmin(this.props.identity) &&
              <div>
                <ColumnLayout columns={2}>
                  <Input
                    placeholder="HCP Attribute Name"
                    value={ this.state.mapping.hcpAttributeName }
                    onChange={ this.onHcpAttributeNameEdit }
                  />
                  <Input
                    placeholder="Phoenix Attribute Name"
                    value={ this.state.mapping.phoenixAttributeName }
                    onChange={ this.onPhoenixAttributeNameEdit }
                  />
                </ColumnLayout>
                <br />
              </div>
            }
            <MappingGroup
              title="Accuracy Benchmark"
              types={this.state.types}
              columnsMap={this.state.columnsMap}
              costCenterOptions={this.props.costCenterOptions}
              mappingEntries={this.state.accuracyBenchmarkMappings}
              componentMappings={this.props.componentMappings}
              subComponentMappings={this.props.subComponentMappings}
              subComponentEdit={this.props.subComponentEdit}
              validate={this.validate}
            />

            <MappingGroup
              title="P&L Benchmark"
              types={[{ label: 'Cognos', id: 'Cognos' }]}
              columnsMap={this.state.columnsMap}
              costCenterOptions={this.props.costCenterOptions}
              mappingEntries={this.state.cognosBenchmarkMappings}
              componentMappings={this.props.componentMappings}
              subComponentMappings={this.props.subComponentMappings}
              subComponentEdit={this.props.subComponentEdit}
              validate={this.validate}
            />

            { this.getBenchmarkConfigurations(mapping.subComponent) }

            <Button
              icon="copy"
              text="Accuracy Benchmark => P&L Benchmark"
              onClick={this.copyToCognosBenchmark}
            />
            <Button
              icon="copy"
              text="P&L Benchmark => Accuracy Benchmark"
              onClick={this.copyToAccuracyBenchmark}
            />
          </div>
        }
      />
    );
  }
}

export default MappingEditor;



// WEBPACK FOOTER //
// ./src/components/mapper/mapping_editor.jsx